import { Route, Redirect, Router } from "react-router-dom";
import "./app.less";
import EmptyPage from "./modules/core/empty";
import LoginPage from "./modules/account/login-page";

import LayoutApp from "./shared/layout/layout-app";
import history from "shared/plugins/history";

import { Loading } from "shared/components/loading/loading";
import ForgotPasswordPage from "modules/account/forgot-password-page";
import RoleManagementPage from "modules/role-management/role-management-page";
import StaticPage from "modules/static-page/static-page";
import { AddUpdateStaticPage } from "modules/static-page/add-update-static-page";
import Contact from "modules/contact/contact";
import BlogCategory from "modules/blog-category/blog-category";
import { AddUpdateBlog } from "modules/blog/add-update-blog";
import Blog from "modules/blog/blog";
import Staff from "modules/staff/staff";
import ThemeSetting from "modules/theme-config/theme-setting-page";
import AddUpdateThemeConfig from "modules/theme-config/add-update-theme-setting";
import MenuSetting from "modules/menu-setting/menu-page";
import ProductCategory from "modules/product-category/product-category";
import Product from "modules/product/product";
import Customer from "modules/customer/customer";
import { AddUpdateProduct } from "modules/product/add-update-product";
import { DefaultShippingFee } from "modules/shipping-fee/default-shipping-fee";
import { ShippingFeeAddress } from "modules/shipping-fee/shipping-fee-address";
import { ShippingFeeOrderAmount } from "modules/shipping-fee/shipping-fee-order-amount";
import { ProductComment } from "modules/product-comment/product-comment";
import ProductAttributeGroup from "modules/product-attribute/product-attribute-group";
import ProductAttribute from "modules/product-attribute/product-attribute";
import ProductAttributeValue from "modules/product-attribute/product-attribute-value";
import Tag from "modules/tag/tag";
import { AddUpdateProductCategory } from "modules/product-category/add-update-product-category";
import CustomerGroup from "modules/customer-group/customer-group";
import { AddUpdateBranch } from "modules/branch/add-update-branch";
import Branch from "modules/branch/branch";
import WebsiteConfig from "modules/website-config/website-config";
import {
  ADD_BRANCH_ROUTE,
  ADD_PRODUCT_CATEGORY_ROUTE,
  ADD_PRODUCT_ROUTE,
  ADD_PROMOTION_CODE_ROUTE,
  ADD_THEME_SETTING_ROUTE,
  ADD_THEME_TEMPLATE_ROUTE,
  ADD_WARE_HOUSE_ROUTE,
  BRANCH_ROUTE,
  COMMENT_ROUTE,
  FIREBASE_CONFIG_ROUTE,
  MODIFIER_GROUP_ROUTE,
  ORDER_REPORT_ROUTE,
  ORDER_ROUTE,
  PAYMENT_SETTING_ROUTE,
  PRODUCT_ATTRIBUTE_GROUP_ROUTE,
  PRODUCT_ATTRIBUTE_ROUTE,
  PRODUCT_ATTRIBUTE_VALUE_ROUTE,
  PRODUCT_CATEGORY_ROUTE,
  PRODUCT_COMMENT_ROUTE,
  PRODUCT_ROUTE,
  PRODUCT_STOCK_ROUTE,
  PROMOTION_CODE_ROUTE,
  SHIPPING_FEE_BY_ADDRESS_ROUTE,
  SHIPPING_FEE_BY_ORDER_AMOUNT_ROUTE,
  SHIPPING_FEE_DEFAULT_ROUTE,
  STAFF_ROUTE,
  SYSTEM_CONFIG_ROUTE,
  TAG_ROUTE,
  THEME_SETTING_ROUTE,
  THEME_TEMPLATE_ROUTE,
  TRANSPORTATION_ROUTE,
  UNIT_ROUTE,
  UPDATE_BRANCH_ROUTE,
  UPDATE_PRODUCT_CATEGORY_ROUTE,
  UPDATE_PRODUCT_ROUTE,
  UPDATE_PROMOTION_CODE_ROUTE,
  UPDATE_THEME_SETTING_ROUTE,
  UPDATE_THEME_TEMPLATE_ROUTE,
  UPDATE_WARE_HOUSE_ROUTE,
  WARE_HOUSE_ROUTE,
  WEBSITE_CONFIG_ROUTE,
} from "shared/constants/routes";
import UnitPage from "modules/unit/unit-page";
import { AddUpdateThemeTemplate } from "modules/theme-template/add-update-theme-template";
import ThemeTemplatePage from "modules/theme-template/theme-template-page";
import { MceEditorModal } from "shared/components/tinymce/mce-editor-modal";
import { SystemConfig } from "modules/system-config/system-config";
import ProductStockPage from "modules/product-stock/product-stock-page";
import WareHousePage from "modules/ware-house/ware-house-page";
import { AddUpdateWareHouse } from "modules/ware-house/add-update-ware-house";
import { ProductStockModal } from "shared/components/product/product-stock-modal";
import OrderPage from "modules/order/order-page";
import { GlobalMessageModal } from "shared/components/modals/global-message-modal";
import { OrderReport } from "modules/order-report/order-report";
import ModifierGroupPage from "modules/modifier-group/modifier-group-page";
import { useFetchAppData } from "shared/hooks/use-fetch-app-data";
import { useNotifyOrderPrinter } from "shared/hooks/use-notify-order-printer";
import { TransportationPage } from "modules/system-config/transportation-page";
import { FirebaseConfig } from "modules/google-setting/firebase-setting";
import { CommentPage } from "modules/comment/comment";
import PromotionCode from "modules/promotion-code/promotion-code-page";
import { AddUpdatePromotionCode } from "modules/promotion-code/promotion-code-add-update";
import { PaymentSettingPage } from "modules/payment-setting/payment-setting-page";

function App() {
  useFetchAppData();
  useNotifyOrderPrinter();

  return (
    <Router history={history}>
      <Loading>
        <Route path="/admin/login" exact={true} component={LoginPage} />
        <Route
          path="/admin/forgot-password"
          exact={true}
          component={ForgotPasswordPage}
        />
        <Route
          path="/admin/forgot-password/:userId/:token"
          exact={true}
          component={ForgotPasswordPage}
        />

        <LayoutApp>
          <Route path={["/admin", ""]} exact={true}>
            <Redirect to={ORDER_REPORT_ROUTE}></Redirect>
          </Route>
          <Route path="/admin/empty" exact={true} component={EmptyPage} />
          <Route
            path="/admin/role-management"
            exact={true}
            component={RoleManagementPage}
          />
          <Route path="/admin/contact" exact={true} component={Contact} />
          <Route path={STAFF_ROUTE} exact={true} component={Staff} />
          <Route path="/admin/customers" exact={true} component={Customer} />
          <Route
            path="/admin/blog-category"
            exact={true}
            component={BlogCategory}
          />
          <Route
            path={PRODUCT_COMMENT_ROUTE}
            exact={true}
            component={ProductComment}
          />
          <Route
            path={PRODUCT_CATEGORY_ROUTE}
            exact={true}
            component={ProductCategory}
          />
          <Route
            path={[
              ADD_PRODUCT_CATEGORY_ROUTE,
              `${UPDATE_PRODUCT_CATEGORY_ROUTE}/:id`,
            ]}
            exact={true}
            component={AddUpdateProductCategory}
          />
          <Route path={COMMENT_ROUTE} exact={true} component={CommentPage} />
          <Route
            path="/admin/static-page"
            exact={true}
            component={StaticPage}
          />
          <Route
            path="/admin/static-page/add"
            exact={true}
            component={AddUpdateStaticPage}
          />
          <Route
            path="/admin/static-page/update/:staticPageId"
            exact={true}
            component={AddUpdateStaticPage}
          />
          <Route
            path="/admin/menu-setting"
            exact={true}
            component={MenuSetting}
          />
          <Route
            path={THEME_SETTING_ROUTE}
            exact={true}
            component={ThemeSetting}
          />
          <Route
            path={[
              ADD_THEME_SETTING_ROUTE,
              `${UPDATE_THEME_SETTING_ROUTE}/:id`,
            ]}
            exact={true}
            component={AddUpdateThemeConfig}
          />

          <Route
            path={THEME_TEMPLATE_ROUTE}
            exact={true}
            component={ThemeTemplatePage}
          />
          <Route
            path={[
              ADD_THEME_TEMPLATE_ROUTE,
              `${UPDATE_THEME_TEMPLATE_ROUTE}/:id`,
            ]}
            exact={true}
            component={AddUpdateThemeTemplate}
          />
          <Route path="/admin/blog" exact={true} component={Blog} />
          <Route
            path="/admin/blog/add"
            exact={true}
            component={AddUpdateBlog}
          />
          <Route
            path="/admin/blog/update/:blogId"
            exact={true}
            component={AddUpdateBlog}
          />
          <Route path={PRODUCT_ROUTE} exact={true} component={Product} />
          <Route
            path={[
              `${UPDATE_PRODUCT_ROUTE}/:productId`,
              `${ADD_PRODUCT_ROUTE}`,
              `${ADD_PRODUCT_ROUTE}/:productId`,
            ]}
            exact={true}
            component={AddUpdateProduct}
          />
          <Route
            path={SHIPPING_FEE_DEFAULT_ROUTE}
            exact={true}
            component={DefaultShippingFee}
          />
          <Route
            path={SHIPPING_FEE_BY_ADDRESS_ROUTE}
            exact={true}
            component={ShippingFeeAddress}
          />
          <Route
            path={SHIPPING_FEE_BY_ORDER_AMOUNT_ROUTE}
            exact={true}
            component={ShippingFeeOrderAmount}
          />
          <Route path={[ORDER_ROUTE]} exact={true} component={OrderPage} />
          <Route
            path={ORDER_REPORT_ROUTE}
            exact={true}
            component={OrderReport}
          />
          <Route
            path={PRODUCT_ATTRIBUTE_GROUP_ROUTE}
            exact={true}
            component={ProductAttributeGroup}
          />
          <Route
            path={PRODUCT_ATTRIBUTE_ROUTE}
            exact={true}
            component={ProductAttribute}
          />
          <Route
            path={PRODUCT_ATTRIBUTE_VALUE_ROUTE}
            exact={true}
            component={ProductAttributeValue}
          />
          <Route path={TAG_ROUTE} exact={true} component={Tag} />
          <Route
            path={MODIFIER_GROUP_ROUTE}
            exact={true}
            component={ModifierGroupPage}
          />
          <Route
            path="/admin/customer-group"
            exact={true}
            component={CustomerGroup}
          />
          <Route path={BRANCH_ROUTE} exact={true} component={Branch} />
          <Route
            path={[ADD_BRANCH_ROUTE, `${UPDATE_BRANCH_ROUTE}/:branchId`]}
            exact={true}
            component={AddUpdateBranch}
          />

          <Route
            path={WARE_HOUSE_ROUTE}
            exact={true}
            component={WareHousePage}
          />
          <Route
            path={[ADD_WARE_HOUSE_ROUTE, `${UPDATE_WARE_HOUSE_ROUTE}/:id`]}
            exact={true}
            component={AddUpdateWareHouse}
          />

          <Route
            path={PROMOTION_CODE_ROUTE}
            exact={true}
            component={PromotionCode}
          />
          <Route
            path={[
              ADD_PROMOTION_CODE_ROUTE,
              `${UPDATE_PROMOTION_CODE_ROUTE}/:id`,
            ]}
            exact={true}
            component={AddUpdatePromotionCode}
          />

          <Route
            path={WEBSITE_CONFIG_ROUTE}
            exact={true}
            component={WebsiteConfig}
          />
          <Route
            path={SYSTEM_CONFIG_ROUTE}
            exact={true}
            component={SystemConfig}
          />
          <Route
            path={PAYMENT_SETTING_ROUTE}
            exact={true}
            component={PaymentSettingPage}
          />
          <Route
            path={FIREBASE_CONFIG_ROUTE}
            exact={true}
            component={FirebaseConfig}
          />
          <Route path={UNIT_ROUTE} exact={true} component={UnitPage} />

          <Route
            path={PRODUCT_STOCK_ROUTE}
            exact={true}
            component={ProductStockPage}
          />

          <Route
            path={TRANSPORTATION_ROUTE}
            exact={true}
            component={TransportationPage}
          />
          <MceEditorModal />
          <ProductStockModal />
        </LayoutApp>
        <GlobalMessageModal />
      </Loading>
    </Router>
  );
}

export default App;
